import { render, staticRenderFns } from "./CompanyListView.vue?vue&type=template&id=56d7fb3a&scoped=true"
import script from "./CompanyListView.vue?vue&type=script&lang=js"
export * from "./CompanyListView.vue?vue&type=script&lang=js"
import style0 from "./CompanyListView.vue?vue&type=style&index=0&id=56d7fb3a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d7fb3a",
  null
  
)

export default component.exports